import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login'
import navigation from '@/views/navigation'
import stockpile from '@/views/stockpile'
import introduce from '@/views/introduce'
import cell from '@/views/cell'
import client from '@/views/client'
import inquire from '@/views/inquire'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/navigation',
      name: '分类',
      component: navigation
    },{
      path: '/introduce',
      name: '集团介绍',
      component:introduce
    },{
      path: '/stockpile',
      name: '储存罐',
      component: stockpile
    },{
      path: '/cell',
      name: '细胞总库',
      component: cell
    },{
      path: '/client',
      name: '客户数据',
      component: client
    },{
      path: '/inquire',
      name: '客户查询',
      component: inquire
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js